module.exports = __webpack_public_path__ + "static/media/search-plus.e1551a24.svg";